import { useEffect, useRef, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import ErrorBoundary from './error-boundary';

interface RouteErrorBoundaryProps {
  children: ReactNode;
  level?: 'root' | 'feature' | 'component';
}

/**
 * Error Boundary wrapper that resets when the route changes.
 * This ensures that navigation continues to work even after an error occurs.
 */
const RouteErrorBoundary = ({ children, level = 'feature' }: RouteErrorBoundaryProps) => {
  const location = useLocation();
  const locationRef = useRef(location.pathname);

  // Force remount of ErrorBoundary when location changes
  useEffect(() => {
    locationRef.current = location.pathname;
  }, [location]);

  return (
    <ErrorBoundary level={level} key={location.pathname}>
      {children}
    </ErrorBoundary>
  );
};

export default RouteErrorBoundary;
